import { render } from "./NaveIcon.vue?vue&type=template&id=60ee5c3c"
import script from "./NaveIcon.vue?vue&type=script&lang=js"
export * from "./NaveIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__